import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { InjectorService } from '@tencent/workbench';

export const getPcInjectedService = (service) => {
    if (browser.isMobile) {
        handleError(service, true);
        return;
    }
    return InjectorService.get(service);
};

export const getMobileInjectedService = (service) => {
    if (!browser.isMobile) {
        handleError(service, false);
        return;
    }
    return InjectorService.get(service);
};

export const getInjectedService = service => InjectorService.get(service);

/**
 * 处理异常
*/
export const handleError = (service, isPc: boolean) => {
    const errorInfo = `${service} should be used on ${isPc ? 'PC' : 'Mobile'}`;
    if (isDevEnvironment) {
        throw new Error(errorInfo);
    } else {
        window.log.error(errorInfo);
    }
};

/**
 * 开发环境
 */
export const isDevEnvironment = process.env.NODE_ENV !== 'production';
